import React from 'react';

import ProductionBomEditView from '@components/shared/production_boms/ProductionBomEditView';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';

import adminProductionBomService from '@services/admin/productionBomService';
import adminProductService from '@services/admin/productService';

export default function AdminProductionBomNew() {
  const { inventoryTypes } = useMerchantData();

  return (
    <ProductionBomEditView
      productionBomService={adminProductionBomService}
      productService={adminProductService}
      inventoryTypes={inventoryTypes}
      role="admin"
    />
  );
}
